module.exports = __webpack_public_path__ + "media/Cinema_movies.4779009e.mp3";